<script lang="ts">
    import {_, time} from 'svelte-i18n'
    import type {Message} from './types';
    import {MessageType} from './types';
    import {replaceUrlsWithLink} from './service/util';

    export interface MessageView {
        cssClass: string
    }

    export let message: Message;
    let messageView: MessageView;

    $: messageView = {
        cssClass: message.type === MessageType.STANDARD_FROM_OPERATOR ? 'from-operator' : 'from-client'
    };

    function toHtml(message: Message) {
        let text = message.text;
        return replaceUrlsWithLink(text);
    }
</script>


<div class="message-container {messageView.cssClass}">
    <div class="mdc-card">
        <div class="mdc-typography--caption" style="text-align: left; color: #b4b4b4; display: flex; justify-content: space-between; margin-top: 4px;">
            <div style="margin-left: 5px; margin-right: 5px;">
                <span style="margin-left: 5px; margin-right: 5px;">
                    {#if message.type === MessageType.STANDARD_FROM_OPERATOR}
                        {$_('message.ConsultantWrote')}
                    {/if}
                    {#if message.type === MessageType.STANDARD_FROM_CLIENT}
                        {$_('message.ClientWrote')}
                    {/if}
                </span>
            </div>
            <div style="margin-left: 5px; margin-right: 5px;">
                {#if message.serverReceiveDate}
                    <span title={$_('message.Sent')} style="margin-left: 5px; margin-right: 5px;">⤴ {$time(message.serverReceiveDate, {format: 'short'})}</span>
                {/if}
                {#if message.firstClientSendDate}
                    <span title={$_('message.Received')} style="margin-left: 5px; margin-right: 5px;">✓ {$time(message.firstClientSendDate, {format: 'short'})}</span>
                {/if}
                {#if message.readDate}
                    <span title={$_('message.Readed')} style="margin-left: 5px; margin-right: 5px;">👁 {$time(message.readDate, {format: 'short'})}</span>
                {/if}
            </div>
        </div>
        <div class="smui-card__content" style="padding: 0 10px 8px; overflow-wrap: break-word;">{@html toHtml(message)}</div>
    </div>
</div>


<style lang="scss">
  .message-container {
    margin: 4px 0;
    white-space: pre-line;
  }

  .from-operator {
    .mdc-card {
      background-color: #c0dde8;
    }
  }
</style>